import { ReactElement, useMemo, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { MenuProps, DropdownProps } from 'antd';
import { ItemType, MenuItemType } from 'antd/es/menu/hooks/useItems';
import { APP_CONFIG } from 'app.config';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'common/components/antd/Dropdown/Dropdown';
import {
  STrigger,
  SIconWrapper,
  SLabel,
} from './LanguageDropdown.styles';

export const LanguageDropdownComponent = ({ menu, ...rest }: DropdownProps): ReactElement => {
  const { t, i18n } = useTranslation();

  const items: MenuProps['items'] = useMemo(
    () =>
      APP_CONFIG.LOCALES.map((item) => ({
        label: t(item.translation),
        key: item.key,
      })),
    [t],
  );

  const [selectedKey, setSelectedKey] = useState(i18n.resolvedLanguage);

  const selectedItem = useMemo<ItemType | undefined>(
    () => items.find((item) => item!.key === selectedKey),
    [selectedKey, items],
  );
  const onClick: MenuProps['onClick'] = ({ key }) => {
    setSelectedKey(key);
    i18next.changeLanguage(key);
  };

  return (
    <Dropdown
      trigger={['click']}
      {...rest}
      menu={{
        onClick,
        items,
        ...menu,
      }}
    >
      <STrigger>
        <SLabel>{(selectedItem as MenuItemType)?.label}</SLabel>
        <SIconWrapper>
          <DownOutlined />
        </SIconWrapper>
      </STrigger>
    </Dropdown>
  );
};
